import React from "react";
import "./Cases.css";

import caseLorena from "../assets/case_lorena1.webp";
import caseAlana from "../assets/case_alana1.webp";
import casePatrick from "../assets/case_patrick1.webp";
import caseJessica from "../assets/case_jessica1.webp";

const Cases = () => {
  const calculateMonths = (startDate) => {
    const start = new Date(startDate);
    const now = new Date();
    return (
      (now.getFullYear() - start.getFullYear()) * 12 +
      (now.getMonth() - start.getMonth()) +
      1 // inclui o mês atual
    );
  };

  const cases = [
    {
      title: "ML Clínica",
      location: "Belo Horizonte, MG",
      period: `${calculateMonths("2022-08-01")} meses`,
      description: `"Guilherme é o meu braço direito, começamos esse negócio juntos. Sem o seu papel como estrategista e gestor comercial dificilmente teríamos chegando até aqui e alcançado a marca de 500 mil de faturamento mensal, constantes. Com sua expertise ele treinou a equipe da Arcadian para buscar o mesmo objetivo para outros profissionais. Que orgulho!"\n<b>– Dra. Lorena Linhares</b>`,
      challenge:
        "Alavancar o faturamento, com uma equipe organizada, trabalhando com apenas com cirurgias estéticas faciais.",
      solution:
        "Foram anos construindo um posicionamento de conteúdo estratégico tornando a Dra.Lorena uma referência em sua área. E com uma metodologia de Gestão de CRM trouxe uma estrutura para bater metas todos os meses",
      image: caseLorena,
    },
    {
      title: "Dr. Patrick Peloso",
      location: "Rio de Janeiro, RJ",
      period: `${calculateMonths("2024-10-01")} meses`,
      description: `"A Arcadian entrou e meu deu clareza. Há anos trabalho com Harmonização e Cirurgias Estéticas Faciais. Sou mentor de mais de 1000 cirurgiões e face e palestrante internacional. Sou parceiro da Arcadian há 1 ano e faturo 6 dígitos todos os meses. A metodologia desse time trouxe clareza para todos nó.s"\n<b>– Dr. Patrick Peloso</b>`,
      challenge:
        "Faturar múltiplos 6 dígitos todos os meses com mentorias e pacientes particulares de cirurgias estéticas faciais.",
      solution:
        "Entramos com o braço de conteúdo estratégico trabalhando muito storytelling com os seus pacientes e treinamentos o seu time comercial com Gestão de CRM.",
      image: casePatrick,
    },
    {
      title: "Dra. Alana Oliveira",
      location: "Belo Horizonte, MG",
      period: `${calculateMonths("2024-10-01")} meses`,
      description: `"Sou parceira da Arcadian há 1 ano. Quando comecei eu faturava 90k por mês com procedimentos de HOF. Hoje eu faturo 300k por mês. Essa parceria contribuiu para abrir completamente a minha mente no que diz respeito a gestão de equipe e estrutura comercial, eu sempre sento com eles para conversar sobre os meus próximos passos, meus sonhos. Se tornaram meu braço direito."\n<b>– Dra. Alana Oliveira</b>`,
      challenge: "Faturar 6 dígitos todos os meses apenas com HOF.",
      solution:
        "Implementamos uma metodologia de gestão interna e gestão comercial. Através da na nossa análise de dados e tráfego pago, levamos o conteúdo estratégico da Dra.Alana para qualificar ainda mais o seu público.",
      image: caseAlana,
    },
    {
      title: "Dra. Jéssica Brasil",
      location: "Divinópolis, MG",
      period: `${calculateMonths("2024-10-01")} meses`,
      description: `"Os meninos da Arcadian mudaram completamente a visão de como me posicionar. Antes os meus conteúdos não eram nada estratégicos, não tinha bom proveito de casos antes e depois. Eu já trabalhei com 6 empresas de marketing, estava complemente sem esperança com esse tipo de trabalho. Eles realmente são diferenciados, entendem tudo sobre o mercado da HO."\n<b>– Dra. Jéssica Brasil</b>`,
      challenge:
        "Não sabia como construir um posicionamento estratégico e tinha o faturamento estagnado abaixo de 30 mil.",
      solution:
        "Focamos em crescimento de seguidores com conteúdos estratégicos para fortalecer o posicionamento. E implementamos uma estratégia de tráfego eficiente com mudança da mentalidade comercial.",
      image: caseJessica,
    },
  ];

  return (
    <section id="cases" className="cases-section" data-aos="fade-in">
      <div className="cases-container">
        <div className="cases-header">
          <span className="cases-label">Cases de Sucesso</span>
          <h2 className="cases-title">
            O que dizem <span className="highlight">nossos clientes</span>
          </h2>
          <p className="cases-subtitle">
            Conheça algumas das transformações que realizamos em clínicas e
            consultórios pelo Brasil, com resultados extraordinários.
          </p>
        </div>

        <div className="cases-list">
          {cases.map((item, index) => (
            <div className="case-card" key={index}>
              <div className="case-content">
                <div className="case-main">
                  <h3 className="case-title">{item.title}</h3>
                  <div className="case-location-period">
                    <span>{item.location}</span>
                    <span>•</span>
                    <span>{item.period}</span>
                  </div>
                  <div
                    className="case-description"
                    dangerouslySetInnerHTML={{
                      __html: item.description.replace(/\n/g, "<br />"),
                    }}
                  ></div>
                  <div className="case-block">
                    <h4>Desafio:</h4>
                    <p>{item.challenge}</p>
                  </div>
                  <div className="case-block">
                    <h4>Solução:</h4>
                    <p>{item.solution}</p>
                  </div>
                </div>

                <div className="case-results">
                  <img src={item.image} alt="Imagem da Clinica" />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="cases-stats">
          <div>
            <div className="stat-value">+250</div>
            <div className="stat-label">Profissionais da Saúde Impactados</div>
          </div>
          <div>
            <div className="stat-value">+R$1 Mi</div>
            <div className="stat-label">Investidos em Anúncio</div>
          </div>
          <div>
            <div className="stat-value">+50 CRMs</div>
            <div className="stat-label">Implementados</div>
          </div>
          <div>
            <div className="stat-value">+100mil</div>
            <div className="stat-label">Leads captados</div>
          </div>
        </div>

        <div className="cases-cta">
          <a
            href="https://wa.me/5577981631390?text=Ol%C3%A1%2C%20vim%20do%20site%20da%20Arcadian%20e%20gostaria%20faturar%20mais%20com%20a%20minha%20cl%C3%ADnica!"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="btn-primary">
              Quero Ser o Próximo Case de Sucesso
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cases;
